import { RoutesPathE } from '../../../declarations/enums/routes';
import useReactRouter from '../../../hooks/useReactRouter';
import useCarbonOffsets, {
  SelectedCarbonOffsetProjectT,
} from '../../CarbonOffsetsPage/hooks/useCarbonOffsets';
import useSustainableActions, {
  SustainableItemsQueryT,
} from '../../SustainableActionsPage/hooks/useSustainableActions';

export type QueryT = {
  sustainableItems?: SustainableItemsQueryT[];
  carbonOffsets?: SelectedCarbonOffsetProjectT[];
};

const usePaymentPage = () => {
  const { navigateTo } = useReactRouter();

  const { selectedSustainableActions, isLoading } = useSustainableActions();
  const { selectedCarbonOffsetProjects } = useCarbonOffsets();

  const handleClickBack = () => {
    if (!!selectedCarbonOffsetProjects?.length && !!selectedSustainableActions.length) {
      navigateTo(RoutesPathE.SUSTAINABLE_ACTIONS_PAGE, {}, true);

      return;
    }

    if (!!selectedSustainableActions.length) {
      navigateTo(RoutesPathE.SUSTAINABLE_ACTIONS_PAGE, {}, true);

      return;
    }

    navigateTo(RoutesPathE.CARBON_OFFSETS_PAGE, {}, true);
  };

  return {
    isLoading,
    sustainableActions: selectedSustainableActions,
    carbonOffsets: selectedCarbonOffsetProjects || [],
    handleClickBack,
  };
};

export default usePaymentPage;
